import React, { useState } from "react";
import theme from "../../styles/theme.json";
import InputMask from "react-input-mask"; // Para CPF e CNPJ

const UserRegistration = () => {
  const logado = true; // Define se o usuário está logado ou não

  const [formData, setFormData] = useState({
    nome: "",
    telefone: "",
    email: "",
    senha: "",
    dataNascimento: "",
    genero: "",
    documentoTipo: "CPF", // "CPF" ou "CNPJ"
    documentoNumero: "",
    cidade: "",
    uf: "",
    cep: "",
    numeroEndereco: "",
    logradouro: "",
  });

  const [isGeneroDropdownOpen, setIsGeneroDropdownOpen] = useState(false);
  const [isDocumentoDropdownOpen, setIsDocumentoDropdownOpen] = useState(false);

  const generoOptions = ["Masculino", "Feminino", "Outro"];
  const documentoOptions = ["CPF", "CNPJ"];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleGeneroSelect = (option) => {
    setFormData({ ...formData, genero: option });
    setIsGeneroDropdownOpen(false);
  };

  const handleDocumentoSelect = (option) => {
    setFormData({ ...formData, documentoTipo: option, documentoNumero: "" });
    setIsDocumentoDropdownOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Dados do usuário enviados: ", formData);
  };

  return (
    <>
      {!logado && (
        <div className="user-registration">
          <h4
            style={{
              fontWeight: "700",
              marginBottom: "10px",
              color: theme.colors.dark,
            }}
          >
            Cadastre-se
          </h4>
          <p style={{ fontSize: "12px" }}>
            Se você já possui um cadastro, faça{" "}
            <a href="/login">login</a>.
          </p>
          <form onSubmit={handleSubmit}>
            {/* Nome */}
            <div className="form-group">
              <label>Nome completo:</label>
              <input
                type="text"
                name="nome"
                value={formData.nome}
                onChange={handleInputChange}
                required
                placeholder="Digite seu nome completo"
              />
            </div>

            {/* Telefone */}
            <div className="form-group">
              <label>Telefone:</label>
              <InputMask
                mask="(99) 99999-9999"
                name="telefone"
                value={formData.telefone}
                onChange={handleInputChange}
                required
                placeholder="(XX) XXXXX-XXXX"
              />
            </div>

            {/* Email */}
            <div className="form-group">
              <label>Email:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                placeholder="seuemail@dominio.com"
              />
            </div>

            {/* Senha */}
            <div className="form-group">
              <label>Senha:</label>
              <input
                type="password"
                name="senha"
                value={formData.senha}
                onChange={handleInputChange}
                required
                placeholder="Digite sua senha"
              />
            </div>

            {/* Data de Nascimento */}
            <div className="form-group">
              <label>Data de Nascimento:</label>
              <input
                type="date"
                name="dataNascimento"
                value={formData.dataNascimento}
                onChange={handleInputChange}
                required
              />
            </div>

            {/* Gênero Dropdown */}
            <div style={{ position: "relative" }}>
              <label>Gênero:</label>
              <div
                onClick={() => setIsGeneroDropdownOpen(!isGeneroDropdownOpen)}
                style={{
                  backgroundColor: theme.colors.light,
                  color: theme.colors.dark,
                  border: `1px solid ${theme.colors.muted}`,
                  borderRadius: "8px",
                  padding: "5px 15px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  fontSize: "14px",
                  marginBottom: "10px",
                }}
              >
                <span>{formData.genero || "Selecione o gênero"}</span>
                <span
                  style={{
                    transform: isGeneroDropdownOpen
                      ? "rotate(180deg)"
                      : "rotate(0)",
                    transition: "0.3s",
                  }}
                >
                  ▼
                </span>
              </div>

              {isGeneroDropdownOpen && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    width: "100%",
                    backgroundColor: theme.colors.light,
                    border: `1px solid ${theme.colors.muted}`,
                    borderRadius: "8px",
                    marginTop: "5px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    fontSize: "14px",
                    zIndex: 10,
                  }}
                >
                  {generoOptions.map((option, index) => (
                    <div
                      key={index}
                      onClick={() => handleGeneroSelect(option)}
                      style={{
                        padding: "5px 15px",
                        cursor: "pointer",
                        color: theme.colors.dark,
                        backgroundColor:
                          formData.genero === option
                            ? theme.colors.primary
                            : theme.colors.light,
                        color:
                          formData.genero === option
                            ? theme.colors.light
                            : theme.colors.dark,
                        borderRadius: "8px",
                        margin: "2px 0",
                        transition: "background-color 0.3s",
                      }}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Tipo de Documento Dropdown */}
            <div style={{ position: "relative" }}>
              <label>Tipo de Documento:</label>
              <div
                onClick={() =>
                  setIsDocumentoDropdownOpen(!isDocumentoDropdownOpen)
                }
                style={{
                  backgroundColor: theme.colors.light,
                  color: theme.colors.dark,
                  border: `1px solid ${theme.colors.muted}`,
                  borderRadius: "8px",
                  padding: "5px 15px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  marginBottom: "10px",
                  fontSize: "14px",
                }}
              >
                <span>{formData.documentoTipo || "Selecione o tipo de documento"}</span>
                <span
                  style={{
                    transform: isDocumentoDropdownOpen
                      ? "rotate(180deg)"
                      : "rotate(0)",
                    transition: "0.3s",
                  }}
                >
                  ▼
                </span>
              </div>

              {isDocumentoDropdownOpen && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    width: "100%",
                    backgroundColor: theme.colors.light,
                    border: `1px solid ${theme.colors.muted}`,
                    borderRadius: "8px",
                    marginTop: "5px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    zIndex: 10,
                    fontSize: "14px",
                  }}
                >
                  {documentoOptions.map((option, index) => (
                    <div
                      key={index}
                      onClick={() => handleDocumentoSelect(option)}
                      style={{
                        padding: "5px 15px",
                        cursor: "pointer",
                        color: theme.colors.dark,
                        backgroundColor:
                          formData.documentoTipo === option
                            ? theme.colors.primary
                            : theme.colors.light,
                        color:
                          formData.documentoTipo === option
                            ? theme.colors.light
                            : theme.colors.dark,
                        borderRadius: "8px",
                        margin: "2px 0",
                        transition: "background-color 0.3s",
                      }}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Número do Documento */}
            <div className="form-group">
              <label>Número do Documento:</label>
              <InputMask
                mask={
                  formData.documentoTipo === "CPF"
                    ? "999.999.999-99"
                    : "99.999.999/9999-99"
                }
                name="documentoNumero"
                value={formData.documentoNumero}
                onChange={handleInputChange}
                required
                placeholder={
                  formData.documentoTipo === "CPF"
                    ? "XXX.XXX.XXX-XX"
                    : "XX.XXX.XXX/XXXX-XX"
                }
              />
            </div>

            {/* Endereço */}
            <div className="form-group">
              <label>Cidade:</label>
              <input
                type="text"
                name="cidade"
                value={formData.cidade}
                onChange={handleInputChange}
                required
                placeholder="Digite sua cidade"
              />
            </div>

            <div className="form-group">
              <label>UF:</label>
              <input
                type="text"
                name="uf"
                value={formData.uf}
                onChange={handleInputChange}
                required
                placeholder="Digite sua UF"
              />
            </div>

            <div className="form-group">
              <label>CEP:</label>
              <InputMask
                mask="99999-999"
                name="cep"
                value={formData.cep}
                onChange={handleInputChange}
                required
                placeholder="XXXXX-XXX"
              />
            </div>

            <div className="form-group">
              <label>Número:</label>
              <input
                type="text"
                name="numeroEndereco"
                value={formData.numeroEndereco}
                onChange={handleInputChange}
                required
                placeholder="Número da residência"
              />
            </div>

            <div className="form-group">
              <label>Logradouro:</label>
              <input
                type="text"
                name="logradouro"
                value={formData.logradouro}
                onChange={handleInputChange}
                required
                placeholder="Rua, Avenida, etc."
              />
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default UserRegistration;
